import { z } from 'zod';

const AGENDA_EVENT_TYPE_ICON = {
  unspecified: null,
  general: 'mb-icon-map-dealer-pin-line',
  airport: 'mb-icon-airport',
  hotel: 'mb-icon-home-line',
  restaurant: 'mb-icon-restaurant',
  coffee_stop: 'mb-icon-coffeestop',
  racetrack: 'mb-icon-racetrack',
  kickoff_location: 'mb-icon-pin-kickoff',
  hub_station: 'mb-icon-pin-finalstation',
};

const AgendaItemSchema = z
  .object({
    id: z.string().uuid(),
    event_type: z.string().nullable(), // could be validated more strictly
    location: z.string().nullable(),
    is_test_drive: z.boolean(),
    test_drive_color: z.object({
      color: z.string().length(7).regex(/^#/), // could be validated more strictly
    }),
    time: z.string().nullable(),
    field_title: z.string(),
    day_number: z.number(),
  })
  .transform((data) => {
    return {
      id: data.id,
      eventType: data.event_type,
      icon: data.event_type ? (AGENDA_EVENT_TYPE_ICON as any)[data.event_type] : null,
      location: data.location,
      isTestDrive: data.is_test_drive,
      testDriveColor: data.test_drive_color,
      time: data.time,
      title: data.field_title,
      day: data.day_number,
    };
  });

const AgendaSectionSchema = z
  .object({
    id: z.string().uuid(),
    title: z.string().nullable(),
    anchor_link: z.string().nullable(),
    agenda_items: AgendaItemSchema.array(),
  })
  .transform((data) => {
    return {
      id: data.id,
      type: 'agenda',
      customHeadline: true,
      lightBg: true,
      title: data.title ?? '',
      anchor: data.anchor_link ?? '',
      agendaItems: data.agenda_items,
    };
  });

export type AgendaItem = z.infer<typeof AgendaItemSchema>;
export type AgendaSection = z.infer<typeof AgendaSectionSchema>;

/**
 * Uses ZOD schema to parse an AgendaSection
 *
 * @param data any
 * @throws ZodError
 * @returns AgendaSection
 */
export const parseAgendaSection = (data: any): AgendaSection => {
  const result = AgendaSectionSchema.safeParse(data);
  if (!result.success) {
    throw result.error;
  } else {
    return result.data;
  }
};
